import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getFeatureAccessType } from '../../../selectors/navigation';
import { partnerShape } from '../types';
import BasePartnerAppSitesSummary from './BasePartnerAppSitesSummary';
import UserConfigurationAppSitesSummary, { USER_CONFIGURATION_PARTNER_NAMES } from './UserConfigurationAppSitesSummary';
import { SECTION_ACCESS_TYPES } from '../../../utils/consts';

// TODO new shelf will use the accountsSupport, remove the const later
const hasUserConfiguration = (partner, accountsSupport) =>
    USER_CONFIGURATION_PARTNER_NAMES.includes(partner.name) || accountsSupport;

const PartnerAppSitesSummaryFactory = props => {
    const { accessType, isSingleAccessLevel } = useSelector(getFeatureAccessType('new_partner_config'));
    const { partner, accountsSupport } = props;
    const summaryProps = {
        ...props,
        canAddAppSite: accessType === SECTION_ACCESS_TYPES.EDIT && isSingleAccessLevel,
    };

    if (hasUserConfiguration(partner, accountsSupport)) {
        return <UserConfigurationAppSitesSummary {...summaryProps} />;
    } else {
        return <BasePartnerAppSitesSummary {...summaryProps} />;
    }
};

PartnerAppSitesSummaryFactory.propTypes = {
    partner: partnerShape.isRequired,
    accountsSupport: PropTypes.bool,
};

export default PartnerAppSitesSummaryFactory;
